import styled from 'styled-components';

import { PageContentContainer } from '../../../../styles/containers.sc';

export const PageContentContainerS = styled(PageContentContainer)`
  padding-top: 30px;
  display: flex;
  flex-direction: column;
`;

export const LoadingContainer = styled.div`
  padding: 150px;
  position: relative;
`;
